export enum ServiceTemplateDetailsTabTypes {
    METADATA = "metadata"
}